import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1",staticStyle:{"display":"inline-block"}},[_c(VBtn,{attrs:{"color":"teal white--text","x-small":"","fab":""},on:{"click":_vm.next}},[_c(VIcon,[_vm._v("double_arrow")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }